import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { usePrivacyConsentStore } from '../hooks/usePrivacyConsentStore';
import { services } from '../constants/services';
import { PrivacyConsentsModal } from './PrivacyConsentsModal';
export const PrivacyConsentsModalWrapper = ({ serviceIds, testId }) => {
    const consents = usePrivacyConsentStore((state) => state.consents);
    const isOpen = usePrivacyConsentStore((state) => state.isOpen);
    const hasPending = useMemo(() => serviceIds.some((id) => {
        const service = services.find((service) => service.id === id);
        if (!service || service.category === 'necessary')
            return false;
        return consents[id] === undefined;
    }), [serviceIds, consents]);
    if (!hasPending && !isOpen)
        return null;
    return _jsx(PrivacyConsentsModal, { serviceIds: serviceIds, testId: testId });
};
